import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit"]

  handleSubmitEnd(event) {
    setTimeout(() => this.submitTarget.disabled = false, 100)
  }
}
